/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const Root = styled.div`
  padding: 22px 12px;
  border: 1px solid ${({ theme }) => theme?.colors?.dangerBorder ?? "rgba(220,38,38,0.2)"};
  background: ${({ theme }) => theme?.colors?.dangerBg ?? "rgba(220,38,38,0.06)"};
  border-radius: 12px;
  display: grid;
  gap: 8px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
`;

const Desc = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${({ theme }) => theme?.colors?.textMuted ?? "#666"};
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export function ErrorState({ title = "Algo deu errado", description, action }) {
  return (
    <Root role="alert">
      <Title>{title}</Title>
      {description ? <Desc>{description}</Desc> : null}
      {action ? <Actions>{action}</Actions> : null}
    </Root>
  );
}

ErrorState.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.node,
};

